module.exports = __webpack_public_path__ + "img/gd.gd43662bd.svg";